export default "__VITE_ASSET__fdd0b7e7__"